import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPostingGroup } from "src/models/Customers/PostingGroup.models";

interface PostingGroupState {
  postingGroups: IPostingGroup[];
  postingGroupToEdit: IPostingGroup | null;
}

const initialState: PostingGroupState = {
  postingGroups: [],
  postingGroupToEdit: null,
};

const postingGroupSlice = createSlice({
  name: "PostingGroup",
  initialState,
  reducers: {
    setPostingGroupList: (state, action: PayloadAction<IPostingGroup[]>) => {
      state.postingGroups = action.payload;
    },
    concatListPostingGroup: (
      state: PostingGroupState,
      action: PayloadAction<IPostingGroup[]>
    ) => {
      state.postingGroups = [...state.postingGroups.concat(action.payload)];
    },
    setPostingGroupToEdit: (
      state,
      action: PayloadAction<IPostingGroup | null>
    ) => {
      state.postingGroupToEdit = action.payload;
    },
    addPostingGroup: (state, action: PayloadAction<IPostingGroup>) => {
      state.postingGroups.push(action.payload);
    },
    updatePostingGroup: (state, action: PayloadAction<IPostingGroup>) => {
      let itemIndex = state.postingGroups.findIndex(
        item =>
          item.customerPostingGroupId === action.payload.customerPostingGroupId
      );
      if (itemIndex !== -1) state.postingGroups[itemIndex] = action.payload;
    },
    deletePostingGroup: (state, action: PayloadAction<number>) => {
      const newArray = state.postingGroups.filter(
        item => item.customerPostingGroupId !== action.payload
      );
      state.postingGroups = newArray;
    },
  },
});

export const {
  setPostingGroupList,
  concatListPostingGroup,
  setPostingGroupToEdit,
  addPostingGroup,
  updatePostingGroup,
  deletePostingGroup,
} = postingGroupSlice.actions;

export default postingGroupSlice.reducer;
